import React from "react";
import { connect } from "react-redux";
import { getClusterPacksStatuses } from "state/cluster/selectors/details";
import {
  faPlay,
  faSquare,
  faTriangle,
} from "@fortawesome/sharp-solid-svg-icons";
import { silver, info, success, error, warning } from "utils/constants/colors";
import { faCircle as faCircleRegular } from "@fortawesome/pro-regular-svg-icons";
import { faCircle as faCircleSolid } from "@fortawesome/pro-solid-svg-icons";
import { Tooltip } from "antd";
import Icon from "components/ui/Icon";

const PACK_STATE_METADATA = {
  loading: {
    icon: faPlay,
    color: info,
  },
  success: {
    icon: faCircleSolid,
    color: success,
  },
  error: {
    icon: faSquare,
    color: error,
  },
  warning: {
    icon: faTriangle,
    color: warning,
  },
  normal: {
    icon: faCircleRegular,
    color: info,
  },
};

function Status({ packStatuses, pack, profileUid }) {
  const packStatus =
    packStatuses[`${profileUid}~${pack.metadata.name}~${pack.spec.version}`];
  const { icon, color } = PACK_STATE_METADATA[packStatus?.state] || {
    color: silver,
    icon: faCircleSolid,
  };

  return (
    <Tooltip placement="top" title={packStatus?.status || ""}>
      <Icon awesome={icon} color={color || silver} />
    </Tooltip>
  );
}

export default connect((state, ownProps) => ({
  packStatuses: getClusterPacksStatuses(state)[ownProps.clusterUid] || {},
}))(Status);
